import { dateToString, ChatMessage } from '@chewy/chat-library-common';
import styles from './MessageStamp.module.scss';
import cn from 'classnames';

interface MessageStampProps {
  message: ChatMessage;
}

export default function MessageStamp({ message }: MessageStampProps) {
  return (
    <div className={cn(styles.baseTimeStampContainer, message.responseType === 'agent' && styles.agentTimeStampContainer)}>
      <span className={cn(styles.baseResponderName, message.responseType === 'agent' && styles.agentResponderName)}>
        {message.responseType === 'agent' ? message.agentName : ''}
      </span>
      <span className={cn(styles.baseTimestamp, message.responseType === 'agent' && styles.agentTimestamp)}>
        {dateToString(new Date(message.responseTimestamp))}
      </span>
    </div>
  );
}

